import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import PainPoints from './components/PainPoints';
import SolutionFlow from './components/SolutionFlow';
import Capabilities from './components/Capabilities';
import Scenarios from './components/Scenarios';
import OperationTimeline from './components/OperationTimeline';
import Security from './components/Security';
import Metrics from './components/Metrics';
import Faq from './components/Faq';
import Consultation from './components/Consultation';

export default function RedPacket() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="数字红包解决方案｜惠民促消费与商户引流｜华辉数智"
        description="华辉数智数字红包解决方案，以数字人民币红包连接政策、商户与消费者，提供从规则配置、精准发放、商户核销到数据复盘的一站式服务，助力消费券发放、节庆营销、商圈引流与乡村振兴。"
        keywords="数字红包,数字人民币红包,惠民促消费,消费券发放,商圈引流,商户核销,乡村振兴,数字营销"
        path="/solutions/red-packet"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '数字红包解决方案',
          description:
            '华辉数智数字红包解决方案，以数字人民币红包连接政策、商户与消费者，让补贴发放更精准、核销更便捷、消费促进更可见。',
        }}
      />

      <Hero />
      <Breadcrumb items={[{ label: '产品与解决方案' }, { label: '解决方案' }, { label: '数字红包' }]} />

      <main>
        <PainPoints />
        <SolutionFlow />
        <Capabilities />
        <Scenarios />
        <OperationTimeline />
        <Security />
        <Metrics />
        <Faq />
        <Consultation />
      </main>

      <Footer />

      {/* 悬浮咨询按钮 */}
      <a
        href="#consultation"
        className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-secondary-500 text-foreground-950 text-sm font-medium shadow-[0_8px_24px_rgba(0,0,0,0.18)] whitespace-nowrap cursor-pointer transition-all hover:bg-secondary-400 hover:-translate-y-0.5"
      >
        <i className="ri-customer-service-2-line"></i>
        咨询方案
      </a>
    </div>
  );
}